module.exports = __webpack_public_path__ + "img/warning.6785d770.svg";